import React, {Suspense} from 'react'
import {Switch, Route, Redirect, useLocation} from 'react-router-dom'
import {shallowEqual, useSelector} from "react-redux";
import Index from './pages/index'
// import ErrorPage from './pages/error-page'
import Draft from './pages/draft'
import SignIn from './pages/auth/signin'
import SignUp from './pages/auth/signup'
import ForgotPassword from './pages/auth/forgot.password'
import {EmailVerifyError, EmailVerifyCompleted} from './pages/auth/email.verify'
import ResetPassword from './pages/auth/reset.password'
import ErrorPage from "./pages/error-page";

// import Users from './pages/users'
// const Users = React.lazy(() => import('./pages/users'))

export function PrivateRoute({
	children,
	component: Component,
	componentProps,
	permission,
	...rest
}) {
	console.log('PrivateRoute!', { componentProps, permission, rest })

	const location = useLocation()

	const restrictedAccessByAuth = React.useMemo(() => () => {
		const pathname = '/auth/signin'
		const state = { from: location }
		return <Redirect to={{ pathname, state }} />
	}, [location])

	const restrictedAccessByPermission = React.useMemo(() => () => {
		const pathname = '/error/nopermission'
		const state = { from: location }
		return <Redirect to={{ pathname, state }} />	
	}, [location])

	const { isLoggedIn, permissions } = useSelector(
		state => {
			return {
				isLoggedIn: state.user.isLoggedIn,
				permissions: state.user.permissions,
			}
		},
		shallowEqual
	)

	if (!isLoggedIn) {
		return restrictedAccessByAuth()
	} else if (
		typeof permission === 'string'
		&& permission.trim().length > 0
		&& Array.isArray(permissions)
	){
		if (permissions.indexOf(permission) < 0) {
			return restrictedAccessByPermission(permission, permissions)
		}
	} else if (typeof permission === 'function') {
		if (!permission(permissions)) {
			return restrictedAccessByPermission(permission, permissions)
		}
	}

	const Loading = (<div>Loading...</div>)
	const render = (props) => {
		const allProps = {
			...props,
			title: `Props through render`,
			...componentProps
		}
		return (<Component { ...allProps } />)
	}
	return (
		<Suspense fallback={Loading}>
			<Route {...rest} render={render} />
		</Suspense>
	);
}

const Routes = () => {
	const {navigationMenu} = useSelector(
		state => ({
			navigationMenu: state.navigationMenu
		}),
		shallowEqual
	)

	return (
		<Switch>
			{/*<Route exact path="/" component={Index} />*/}
			<Route exact path="/">
				<Redirect to="/dashboard" />
			</Route>

			{/* <Route path="/draft" component={Draft}/> */}
			<Route path="/auth/signin" component={SignIn}/>
			<Route path="/auth/signup" component={SignUp}/>
			<Route path="/auth/email/verify/error" component={EmailVerifyError}/>
			<Route path="/auth/email/verify/completed" component={EmailVerifyCompleted}/>
			<Route path="/auth/forgot-password" component={ForgotPassword}/>
			<Route path="/auth/reset-password/:token" component={ResetPassword}/>

			{
				navigationMenu.reduce((menu, currentValue) => {
					currentValue.items.map((subMenu) => {
						return menu.push(
							<PrivateRoute
								key={subMenu.url}
								path={subMenu.url}
								permission={subMenu.permission}
								component={ React.lazy(() => import(`./pages${subMenu.url}/`) )}
							/>
						)
					})

					return menu
				}, [])
			}

			<PrivateRoute component={ErrorPage}/>
		</Switch>
	)
}
export default Routes
